import { DefaultError, QueryClient, QueryKey, useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import { passengerCMSApi } from "~/Services";

interface DocumentDetailsResponse {
  id: number;
  title: string;
  metaTitle_en: string;
  title_ms: string;
  title_zh: string;
  metaTitle_ms: string;
  metaTitle_zh: string;
  metaDescription_en: string;
  metaDescription_ms: string;
  metaDescription_zh: string;
  metaImage: string;
  published: boolean;
  image: string;
  status: any;
  airports: string[];
}

// edit api call
const fetchSubCategoriesDetails = async (): Promise<any> => {
  const response: any = await passengerCMSApi.get(`/api/useful-tips-header-text/all-fields`);
  return response?.data?.[0];
};

const useSubCategoriesDocumentDetails = (
  options?: UseQueryOptions<DocumentDetailsResponse, DefaultError, DocumentDetailsResponse, QueryKey>,
  queryClient?: QueryClient
): UseQueryResult<DocumentDetailsResponse, DefaultError> => {
  return useQuery<DocumentDetailsResponse, DefaultError, DocumentDetailsResponse, QueryKey>(
    {
      queryKey: ["subCategoriesDocumentDetails"],
      enabled: false,
      queryFn: () => {
        return fetchSubCategoriesDetails();
      },
      refetchOnWindowFocus: false,
      ...options,
    },
    queryClient
  );
};

export { useSubCategoriesDocumentDetails };
